import _sortBy from "lodash/sortBy"

const getItemImagesFromPrismicImageItems = (imageItems = [], PAGE_TYPE) => {
  if (PAGE_TYPE === "collection") {
    let filteredImageItems = imageItems.filter(
      imageItem =>
        !!imageItem.include_in_collections && imageItem.listingPageImage
    )

    let sortedImageItems = _sortBy(filteredImageItems, ["order"])

    const listingPageImages = sortedImageItems.map(imageItem => ({
      fluid: imageItem.listingPageImage,
    }))

    return listingPageImages
  } else if (PAGE_TYPE === "shopItem") {
    let shopImageItems = imageItems.filter(
      imageItem =>
        !!imageItem.include_in_shop &&
        imageItem.shopImage &&
        imageItem.shopThumbnailImage
    )

    let sortedShopImageItems = _sortBy(shopImageItems, ["order"])

    const shopImages = sortedShopImageItems.map(imageItem => ({
      fluid: imageItem.shopImage,
    }))
    const thumbImages = sortedShopImageItems.map(imageItem => ({
      fixed: imageItem.shopThumbnailImage,
    }))

    return { shopImages, thumbImages }
  } else {
    console.warn(
      `getItemImagesFromPrismicImageItems: Unknown page type supplied = ${PAGE_TYPE}`
    )
    return null
  }
}

export default getItemImagesFromPrismicImageItems